import Catch from './Error/ErrorHandler';
import { Fragment } from 'react';
import { ErrorComponentBehoerdenServer } from './Error/ErrorComponent';
import { BaseLayout } from '@efast_public/fjd-component-library';
type Props = {
  children: React.ReactNode;
};

export const BehErrorBoundary = Catch(function BehErrorBoundary(
  props: Props,
  error?: Error
) {
  if (error) {
    return (
      <BaseLayout
        footer={<div></div>}
        header={<div></div>}
        navigation={<div></div>}
        mainContent={<ErrorComponentBehoerdenServer />}
      />
    );
  } else {
    return <Fragment>{props.children}</Fragment>;
  }
});
